import { Effect, Redacted, Result } from "effect";
import { Digest } from "../digest/service.ts";
import { type DigestInvocationError } from "../errors/digest.ts";
import { canonicalJsonBytes } from "./serialize.ts";
import { type CanonicalJsonError } from "./model.ts";

/** The accepted digest includes lazy serialization and native await adoption. */
export const canonicalJsonDigest = Effect.fn("CanonicalJson.digest")(function* (value: unknown) {
  const digest = yield* Digest;
  let refused: CanonicalJsonError | undefined;
  return yield* digest.sha256Lazy(() => Result.getOrThrowWith(canonicalJsonBytes(value), failure => refused = failure), "after-digest").pipe(
    Effect.mapError((failure): CanonicalJsonError | DigestInvocationError => refused && Redacted.value(failure.cause) === refused ? refused : failure),
    Effect.uninterruptible
  );
});
